export default "__VITE_ASSET__DD4K6E$N__"